/* eslint-disable */
// @ts-nocheck
import { ReduxAsyncAction } from '../../support/utils';

const UpdateCreationDialog = new ReduxAsyncAction('UPDATE_CREATION_DIALOG');
UpdateCreationDialog.registerRequest(async (open: boolean) => {
  return { open };
});

export const UPDATE_CREATION_DIALOG: any = UpdateCreationDialog.constants;
export const updateCreationDialog = UpdateCreationDialog.request;
